import { Component } from '@angular/core';
import { CardBodyComponent, CardComponent, CardHeaderComponent, ColComponent, ContainerComponent, RowComponent } from '@coreui/angular-pro';
import { CommonModule, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ChartjsComponent } from '@coreui/angular-chartjs';
import { DataTablesModule } from 'angular-datatables';
import { DepotInsight } from '../../../models/depot-insight.model';
import { DepotInsightService } from '../../../services/depot-insight.service';
@Component({
  selector: 'app-depot-insights',
  standalone: true,
  imports: [ChartjsComponent, ContainerComponent, RowComponent, ColComponent, CardComponent, CardBodyComponent, CommonModule, CardHeaderComponent, DataTablesModule],
  templateUrl: './depot-insights.component.html',
  styleUrl: './depot-insights.component.scss'
})
export class DepotInsightsComponent {
  repairerSummaryData = {
    labels: ["Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
    datasets: [
      {
        label: "Average number of days vehicle time spent at repairer",
        data: [4, 5, 6, 3, 8, 9], // Example data points for each month
        fill: false, // No fill under the line
        borderColor: "#4DB6AC", // Line color
        tension: 0.4, // Smoothing the line curve
        borderWidth: 3 // Thickness of the line
      }
    ]
  };

  repairerSummaryOptions = {
    scales: {
      y: {
        beginAtZero: true,
        max: 10,
        title: {
          display: true,
          text: "Days"
        }
      },
      x: {
        title: {
          display: true,
          text: "Months"
        }
      }
    },
    plugins: {
      legend: {
        display: false // Hides the legend to match the style in the image
      },
      tooltip: {
        enabled: true
      }
    }
  };
  depotInsightData: DepotInsight[] = [];

  constructor(private depotInsightService: DepotInsightService) {}

  ngOnInit(): void {
    this.depotInsightService.getDepotInsightData().subscribe((data) => {
      this.depotInsightData = data;
    });
  }
  handleChartRef($chartRef: any) {
    if ($chartRef) {
      setTimeout(() => {
        $chartRef?.update();
      }, 3000);
    }
  }
}
